import { NodoFormulario_lite } from './NodoFormulario';
import { BeaconPlano } from 'interiores-mapa/dist/beaconPlano';

export class BalizaFormulario {

	Id: string;
	IdHardware: string;
	DescInstalacion: string;
	FechaInstalacion: Date;
	NivelBateria: Number;
	TimestampLecturaBateria: string;
	PasswordBeacons: string;
	potenciaTx: Number;
	FechaAlta: Date;
	FechaBaja: Date;
	FechaLecturaBateria: Date;
	X: Number;
	Y: Number;
	Latitud: Number;
	Longitud: Number;
	IconoRepresentacion: string;
	TipologiaNombre: string;

	nodos: NodoFormulario_lite[];

	// Objeto de Breeze
	ENTIDAD: any;
	SECCIONES: any[];
	ALA_PLANO: any;
	TIPOLOGIA_BALIZA: any;
	BALIZA_PLANO: BeaconPlano = BeaconPlano.createInstance();

	constructor() {
		this.ENTIDAD = {};
		this.SECCIONES = [];
		this.Id = '';
		this.IdHardware = '';
		this.DescInstalacion = '';
		this.FechaInstalacion = null;
		this.NivelBateria = 0;
		this.TimestampLecturaBateria = '';
		this.FechaLecturaBateria = null;
		this.PasswordBeacons = '';
		this.potenciaTx = 0;
		this.FechaAlta = null;
		this.FechaBaja = null;
		this.X = 0;
		this.Y = 0;
		this.Latitud = 0;
		this.Longitud = 0;
		this.nodos = [];
		this.BALIZA_PLANO = BeaconPlano.createInstance();
		this.TipologiaNombre = '';
		this.IconoRepresentacion = 'assets/itsoft/IconosSVG/SVG/' + 'nodo-baliza.svg';
	}

	fromENTIDAD(ENTIDAD: any): BalizaFormulario{

		this.ENTIDAD = ENTIDAD;
		this.Id = ENTIDAD.Id;
		this.IdHardware = ENTIDAD.IdHardware;
		this.DescInstalacion = ENTIDAD.DescInstalacion;
		this.FechaInstalacion = ENTIDAD.FechaInstalacion;
		this.NivelBateria = ENTIDAD.NivelBateria;
		this.TimestampLecturaBateria = ENTIDAD.TimestampLecturaBateria;
		this.FechaLecturaBateria = ENTIDAD.FechaLecturaBateria;
		this.PasswordBeacons = ENTIDAD.PasswordBeacons;
		this.potenciaTx = ENTIDAD.potenciaTx;
		this.FechaAlta = ENTIDAD.FechaAlta;
		this.FechaBaja = ENTIDAD.FechaBaja;
		this.X = ENTIDAD.X;
		this.Y = ENTIDAD.Y;
		this.Latitud = ENTIDAD.Latitud;
		this.Longitud = ENTIDAD.Longitud;

		ENTIDAD.NODOS.forEach(Nodo_has_baliza => {
			if (Nodo_has_baliza && Nodo_has_baliza.NODO) {
				const nodo: NodoFormulario_lite = new NodoFormulario_lite().fromENTIDAD(Nodo_has_baliza.NODO);
				this.nodos.push(nodo);
			}
		});

		ENTIDAD.NODOS.forEach(Nodo_has_baliza => {
			if (Nodo_has_baliza && Nodo_has_baliza.NODO) {

				if (Nodo_has_baliza.NODO.SECCION) {
					const asignada = this.SECCIONES.find( x => x.Id === Nodo_has_baliza.NODO.SECCION.Id);
					if (!asignada) {
						this.SECCIONES.push(Nodo_has_baliza.NODO.SECCION);
					}
				}
			}
		});

		this.ALA_PLANO = this.ENTIDAD.ALA_PLANO;
		this.TIPOLOGIA_BALIZA = ENTIDAD.TIPOLOGIA_BALIZA;

		if (this.TIPOLOGIA_BALIZA) {
			this.TipologiaNombre = this.TIPOLOGIA_BALIZA.Nombre;
		}

		return this;
	}

	fromBeaconPlano(cont: BeaconPlano): BalizaFormulario{
		this.BALIZA_PLANO = cont;
		if (this.BALIZA_PLANO.ENTIDAD) {
			return this.fromENTIDAD(this.BALIZA_PLANO.ENTIDAD);
		}
		return this;
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/BalizaFormulario.ts